import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import {getMqttDoubleCheck, getMqttType, getTopicsDetail, putTopics, regTopics} from "../../api/apiClient";
import Swal from "sweetalert2";

const MQTTAcntReg = ({
                       setShow,
                       propAccInfo,
                       propSetPopupReg,
                       updateList
                     }) => {

  const [mode, setMode] = useState('');

  const [mqttType, setMqttType] = useState([]);

  useEffect(() => {
    getMqttType().then((res) => {
      setMqttType(res.data.data.list);
    });

    // console.log(propAccInfo.mqtt_id);
    if (propAccInfo.mqtt_id !== undefined) {
      getTopicsDetail(propAccInfo.mqtt_id)
          .then((res) => {
            // console.log(res);
            setMqttAcntInfo(prevState => {
              return {...prevState, mqtt_id: res.data.data.mqtt_id, se: res.data.data.se, prpos: res.data.data.prpos};
            });
          })
          .catch((err) => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
      setMode('put'); // 수정
      setMqttIdChecked(true);
    } else {
      setMode('post');  // 등록
    }
  }, []);

  const [mqttAcntInfo, setMqttAcntInfo] = useState({
    se: '',	// 구분
    mqtt_id: '',    // Mqtt ID
    prpos: '',    // 용도
    password: '',    // 비밀번호
    password_ck: '',    // 비밀번호확인
  });

  const [mqttIdChecked, setMqttIdChecked] = useState(false);
  const [mqttPwChecked, setMqttPwChecked] = useState(false);

  const onChangeInfo = (name, value, isMany = false) => {
    let newInfo = {...mqttAcntInfo};
    if (isMany) {
      for (let i = 0; i < name.length; i++) {
        newInfo[name[i]] = value[i]
        //console.log(`${name[i]} : ${value[i]}`);
      }
    } else {
      newInfo[name] = value;
      //console.log(`${name} : ${value}`);
    }

    setMqttAcntInfo(newInfo);
    // console.log(newInfo);
  };

  const inspectMqttIdDoubleCheck = () => {
    getMqttDoubleCheck(mqttAcntInfo.mqtt_id)
        .then((res) => {
          // console.log(res);
          if (res.data.data.isExist) {
            setMqttIdChecked(false);
            Swal.fire('이미 사용중인 ID 입니다.');
          } else {
            setMqttIdChecked(true);
            Swal.fire('사용 가능한 ID 입니다.');
          }
        })
        .catch(err => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
  };

  const inspectMqttPwCheck = () => {
    if (mqttAcntInfo.password === mqttAcntInfo.password_ck) {
      setMqttPwChecked(true);
    } else {
      setMqttPwChecked(false);
    }
  };

  const onSubmitMQTTAcntForm = () => {
    // console.log("## mqttAcntInfo :: ", mqttAcntInfo);
    if (mqttAcntInfo.se === '') {
      Swal.fire("구분은 필수 항목입니다.");
      return;
    }
    if (mqttAcntInfo.mqtt_id === '') {
      Swal.fire("MQTT ID는 필수 항목입니다.");
      return;
    }

    //inspectMqttPwCheck();

    // console.log("## mode :: ", mode);

    if (mode === 'post') {

      if (mqttAcntInfo.password === '') {
        Swal.fire("비밀번호를 입력하세요");
        return;
      }
      if (mqttAcntInfo.password_ck === '') {
        Swal.fire("비밀번호 확인을 입력하세요");
        return;
      }
      if (mqttAcntInfo.password !== mqttAcntInfo.password_ck) {
        Swal.fire("비밀번호를 확인하세요");
        return;
      }

      if (mqttIdChecked) {
        regTopics(mqttAcntInfo)
            .then((res) => {
              setShow();
              updateList();
              let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
      } else {
        Swal.fire('[확인] 버튼을 눌러 아이디 중복여부를 확인해주세요.');
      }

    } else if (mode === 'put') {
      if (mqttAcntInfo.password !== '') {

        if (mqttAcntInfo.password_ck === '') {
          Swal.fire("비밀번호 확인을 입력하세요");
          return;
        }

        if (mqttAcntInfo.password !== mqttAcntInfo.password_ck) {
          Swal.fire("비밀번호를 확인하세요");
          return;
        }
      }

      putTopics(mqttAcntInfo)
          .then((res) => {
            // console.log(res);
            setShow();
            updateList();
            Swal.fire(
                '정상적으로 처리 되었습니다!',
                '',
                'success'
            );
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }
  };


  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'mqtt-register-form py-3'}
                      id={'mqttRegisterForm'}
                  >
                    <Row className={""}>
                      <Col md={6}>
                        <Row>
                          <Col md={12}>
                            <Form.Group as={Row} controlId="formGtwyId">
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>구분
                              </Form.Label>
                              <Col md={9} className={''}>
                                <Form.Select
                                    aria-label="Default select example"
                                    className={"input input-select"}
                                    defaultValue={(mqttAcntInfo !== null) ? mqttAcntInfo.se : '' || ''}
                                    key={mqttAcntInfo.se}
                                    onChange={(e) => {
                                      onChangeInfo('se', e.target.value)
                                    }}
                                    required
                                >
                                  <option value={""}>선택</option>
                                  {Array.isArray(mqttType) ?
                                      (mqttType.map((elem, idx) => {
                                        return (
                                            <option key={idx} value={elem.cd}>{elem.nm}</option>
                                        )
                                      })) : ''}
                                </Form.Select>
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp1Addr'>
                              <Form.Label column md={3} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>MQTT ID
                              </Form.Label>
                              <Col md={6} className={''}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    // defaultValue={mqttAcntInfo.mqtt_id || ''}
                                    value={mqttAcntInfo.mqtt_id || ''}
                                    onChange={(e) => {
                                      onChangeInfo('mqtt_id', e.target.value)
                                    }}
                                    required
                                />
                              </Col>
                              <Col md={3}>
                                <Button className={"btn btn-secondary w-100"}
                                        onClick={inspectMqttIdDoubleCheck}
                                >확인</Button>
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId='formIp2Addr'>
                              <Form.Label column md={3} className={'label text-end'}>
                                용도
                              </Form.Label>
                              <Col md={9}>
                                <Form.Control
                                    type='text'
                                    className={'input text-white'}
                                    // disabled={true}
                                    // defaultValue={(mqttAcntInfo !== null) ? mqttAcntInfo.prpos : '' || ''}
                                    value={(mqttAcntInfo !== null) ? mqttAcntInfo.prpos : '' || ''}
                                    onChange={(e) => {
                                      onChangeInfo('prpos', e.target.value)
                                    }}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                        </Row>
                      </Col>
                      <Col md={6}>
                        <Row>
                          <Col md={12}>
                            <Form.Group as={Row} controlId="formPassword">
                              <Form.Label column md={4} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>비밀번호
                              </Form.Label>
                              <Col md={8} className={''}>
                                <Form.Control
                                    type='password'
                                    className={'input text-white'}
                                    // defaultValue={(mqttAcntInfo !== null) ? mqttAcntInfo.password : '' || ''}
                                    value={(mqttAcntInfo !== null) ? mqttAcntInfo.password : '' || ''}
                                    onChange={(e) => {
                                      onChangeInfo('password', e.target.value)
                                    }}
                                    required
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col md={12}>
                            <Form.Group as={Row} controlId="formPasswordConfirm">
                              <Form.Label column md={4} className={'label text-end fw-bold'}>
                                <span className={"text-danger"}>* </span>비밀번호 확인
                              </Form.Label>
                              <Col md={8} className={''}>
                                <Form.Control
                                    type='password'
                                    className={'input text-white'}
                                    // defaultValue={(mqttAcntInfo !== null) ? mqttAcntInfo.password_ck : '' || ''}
                                    value={(mqttAcntInfo !== null) ? mqttAcntInfo.password_ck : '' || ''}
                                    onChange={(e) => {
                                      onChangeInfo('password_ck', e.target.value);
                                    }}
                                    required
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>

            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'justify-content-center'}>
                <Button className={'btn save-btn w-100'}
                        onClick={onSubmitMQTTAcntForm}
                >저장</Button>
              </Col>
              <Col md={2} className={'justify-content-center text-end'}>
                <Button className={'btn btn-secondary w-100'} onClick={setShow}>취소</Button>
              </Col>
            </Row>
          </Col>

        </Row>
      </Container>
  );
};

export default MQTTAcntReg;
